import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=20b11e2a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=20b11e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b11e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b11e2a')) {
      api.createRecord('20b11e2a', component.options)
    } else {
      api.reload('20b11e2a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=20b11e2a&scoped=true&", function () {
      api.rerender('20b11e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8XRiGNrO6jBqL/JS/comp/GuestBox.vue"
export default component.exports